// Expected Props :
// showAcceptBtnSpinner
// showCloseIcon
// showRejectBtnSpinner
// acceptBtnTxt
// closeBtnTxt
// rejectBtnTxt
// notificationInfoTxt
// notificationTxt
// notificationType (light, dark, warning)
// acceptBtnFunc
// closeBtnFunc
// rejectBtnFunc

import React from 'react';

import NotificationComponentRender from './notificationComponentRender';
export default class NotificationComponent extends React.Component {
  render() {
    return (
      <NotificationComponentRender
        showAcceptBtnSpinner={this.props.showAcceptBtnSpinner}
        showCloseIcon={this.props.showCloseIcon}
        showRejectBtnSpinner={this.props.showRejectBtnSpinner}
        acceptBtnTxt={this.props.acceptBtnTxt}
        closeBtnTxt={this.props.closeBtnTxt}
        rejectBtnTxt={this.props.rejectBtnTxt}
        notificationInfoTxt={this.props.notificationInfoTxt}
        notificationInfoTxtComponent={this.props.notificationInfoTxtComponent}
        notificationTxt={this.props.notificationTxt}
        notificationType={this.props.notificationType}
        acceptBtnFunc={this.props.acceptBtnFunc}
        closeBtnFunc={this.props.closeBtnFunc}
        rejectBtnFunc={this.props.rejectBtnFunc}
      />
    );
  }
}
